
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import UiMenuContent from './content.vue';
import Vue, { CreateElement } from 'vue';

@Component
export default class UiMenu extends Vue {
  @Prop()
  contentClass: string;
  
  @Prop()
  menuKeyOfSelectedItem: string;

  @Prop()
  nudgeLeft: number;

  @Prop()
  nudgeRight: number;

  @Prop()
  nudgeTop: number;

  @Prop()
  nudgeBottom: number;

  @Prop()
  nudgeWidth: number;

  @Prop()
  offsetX: boolean;

  @Prop()
  offsetY: boolean;

  @Prop()
  value: boolean;

  @Prop()
  hasTriangle: boolean;

  @Prop()
  items: Bemob.ListItem[];

  @Prop()
  bottom: boolean;

  @Prop()
  right: boolean;

  @Prop()
  left: boolean;

  @Prop()
  top: boolean;

  @Prop()
  submenu: boolean;

  @Prop()
  filter: boolean;

  @Prop()
  menuProps: any;

  @Prop()
  positionX: number;

  @Prop()
  positionY: number;

  @Prop()
  openOnHover: boolean;

  @Prop()
  lazy: boolean;

  @Prop()
  stickToRight: boolean;

  @Prop()
  selected: string;

  @Emit('action')
  onAction() {}

  @Prop({default: false})
  closeOnContentClick: boolean;

  pOpen: boolean = false;

  toggle(status: boolean = !this.open) {
    this.open = status;
  }

  redraw() {
    const menu = this.$refs.menu as any;
    menu.updateDimensions();
  }

  get open() {
    return this.pOpen;
  }

  set open(value: boolean) {
    this.pOpen = value;
    if(value) {
      const menuContent = this.$refs.menuContent as UiMenuContent;
      menuContent.clear();
    }
    this.$emit('input', this.pOpen);
  }

  @Watch('value', { immediate: true})
  onValueChanged(value: boolean) {
    this.pOpen = value;
  }

  get classes() {
    let result = ['no-bwaff-fix', 'ui-menu'];

    if(this.contentClass) {
      result.push(this.contentClass);
    }

    if(this.hasTriangle) {
      result.push('ui-menu--has-triangle');
    }

    if(this.stickToRight) {
      result.push('ui-menu--stick-to-right');
    }

    if(this.submenu) {
      result.push('ui-menu--submenu');
    }

    return result.join(' ');
  }

  handleAction() {
    this.onAction();
    this.open = false;
  }

  genProps() {
    return {
      value: this.pOpen,
      contentClass: this.classes,
      transition: false,
      offsetX: this.offsetX,
      offsetY: this.offsetY,
      nudgeLeft: this.nudgeLeft,
      nudgeRight: this.nudgeRight,
      nudgeTop: this.nudgeTop,
      nudgeBottom: this.nudgeBottom,
      nudgeWidth: this.nudgeWidth,
      closeOnContentClick: this.closeOnContentClick,
      left: this.left,
      bottom: this.bottom,
      right: this.right,
      top: this.top,
      positionX: this.positionX,
      positionY: this.positionY,
      openOnHover: this.openOnHover,
      lazy: this.lazy
    };
  }

  genDefaultSlot() {
    const h = this.$createElement;
    return h(
        'ui-menu-content',
        {
          ref: 'menuContent',
          props: {
            submenu: this.submenu,
            filter: this.filter,
            items: this.items,
            menuProps: this.menuProps,
            selected: this.selected
          },
          on: {
            action: ($event: any) => this.handleAction(),
          },
          scopedSlots: this.genContentScopedSlots()
        }
    );
  }

  genSlots() {
    const h = this.$createElement;
    let result: any[] = [];
    const allowedSlots: string[] = [ 'activator', 'menu' ];
    let defaultSlot: any = null;

    if(this.$slots) {
      allowedSlots
          .filter((slotName) => !!this.$slots[slotName])
          .forEach((slotName) => {
            if(slotName === 'menu') {
              defaultSlot = this.$slots[slotName];
            } else {
              const slotProp = {
                slot: slotName
              };

              const slot = h(
                  'template',
                  slotProp,
                  this.$slots[slotName]
              );
              result.push(slot);
            }
          });
    }

    defaultSlot = defaultSlot || this.genDefaultSlot();
    result.push(defaultSlot);


    return result;
  }

  genScopedSlots() {
    const keys = Object.keys(this.$scopedSlots);
    const disallowedSlots: string[] = [ 'activator', 'item' ];

    let result: any = {};
    keys.forEach((key) => {
      if(!disallowedSlots.includes(key)) {
        result[key] = this.$scopedSlots[key];
      }
    });

    return result;
  }

  genContentScopedSlots() {
    const h = this.$createElement;
    let result: any = {};
    const allowedSlots: string[] = [ 'item' ];

    if(this.$slots) {
      allowedSlots
          .filter((slotName) => !!this.$scopedSlots[slotName])
          .forEach((slotName) => {
            result[slotName] = this.$scopedSlots[slotName];
          });
    }

    return result;
  }

  render(h: CreateElement) {
    return h(
        'v-menu',
        {
          ref: 'menu',
          props: this.genProps(),
          on: {
            input: ($event: any) => this.$emit('input', $event),
            action: ($event: any) => this.$emit('action', $event),
            keyup: ($event: any) => this.$emit('keyup', $event),
            focus: ($event: any) => this.$emit('focus', $event),
            blur: ($event: any) => this.$emit('blur', $event),
          },
          scopedSlots: this.genScopedSlots()
        },
        this.genSlots()
    );
  }
}
